import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withLocalize } from 'react-localize-redux';
import { isNullOrUndefined } from '../../store/storeFunctions';
import { generate as generateReportLinks, renderLink } from './reportLinks';
import { popupActions } from '../../store/popupStore';
import { bindActionCreators } from 'redux'
import classnames from 'classnames';

import '../../css/common/reportLinksButtons.scss'

class ReportLinksButtons extends React.Component {

    render() {
        if (isNullOrUndefined(this.props.reports) || isNullOrUndefined(this.props.entityId))
            return null;

        const openNewWindow = this.props.openNewWindow === true;
        return (
            <span
                className={classnames('report-links', { 'report-links-column': this.props.column })}
                onMouseDown={(e) => e.stopPropagation()} onMouseUp={(e) => e.stopPropagation()}
            >
                {generateReportLinks(this.props.entityId, this.props.reports, this.props.includeQuickReport || false, true).map(link =>
                    renderLink(link.url, link.translationKey, openNewWindow, link.primaryAttr, true, this.props.translate, this.props.extraClass || '', this.props.useShort || false, link.translationKey === "Links.NI" ? this.props.entityId : null, link.type, this.props)
                )}
            </span>
        )
    }
}

export default withRouter(withLocalize(connect(
    state => ({}), dispatch => bindActionCreators(({ ...popupActions }), dispatch)
)(ReportLinksButtons)));